/**
 * @desc 时效看板-导出时效看板
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.timelinessDashboard.exportExcelPurchaseInfo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessDashboard/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
